import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
// import Checkbox from '../../components/uielements/checkbox';
// import Button from '../../components/uielements/button';
import Amplify, { API, Auth, graphqlOperation, Logger } from 'aws-amplify';
import OtpInput from 'react-otp-input';

import { AuthPiece } from 'aws-amplify-react';
import { Button, Icon, Modal, notification, Radio, Row } from 'antd';
import renderHTML from 'react-render-html';
import sha from 'sha.js';
import * as QRCode from 'qrcode';
import PhoneInput from 'react-phone-number-input';
import Alert from '../../components/feedback/alert';
import Tooltip from '../../components/uielements/tooltip';
import logo from '../../image/login_graphic.png';
import portal_logo from '../../image/logo.png';

import './singin.css';
import graphql_endpoint from '../../aws-appsync-url';
import SignInStyleWrapper from './signin.style';
import Input from '../../components/uielements/input';
import { store } from '../../redux/store';
import fetchUrl from '../../helpers/fetchUrl';
import { LogUserAuthEvent } from '../../graphql/queries';
import {
  getAppsAPI,
  getCurrentPlan,
  getEnterprisePlan,
  getPayersList,
  getPracticeTimezone,
  getProgressNoteName,
} from '../../helpers/helper';
// import Cookies from 'universal-cookie';

// const cookies = new Cookies();
// import * as authenticator from 'otplib/authenticator';
// const authenticator = window.otplib.authenticator;

const keyuri = (user = 'user', service = 'service', secret = '') => {
  const data = '{service}:{user}?secret={secret}&issuer={service}';
  const protocol = 'otpauth://totp/';
  const value = data
    .replace('{user}', user)
    .replace('{secret}', secret)
    .replace(/{service}/g, service);
  return protocol + value;
};

const federated_data = {
  google_client_id: '740167288482-0rtjn1h7ever08p2stu4aladqlsahfen.apps.googleusercontent.com',
  facebook_app_id: '1986733444910599',
};

const FederatedButtons = props => (
  <div className='isoInputWrapper isoOtherLogin'>
    <Button onClick={props.facebookSignIn} type='primary btnFacebook'>
      Sign in with Facebook
    </Button>
    <Button onClick={props.googleSignIn} type='primary btnGooglePlus'>
      Sign in with Google
    </Button>
  </div>
);

const mutation = type => {
  return `mutation edit${type}($id: String!, $input: EditInput!) {
    edit${type}(providerId: $id, input: $input) {
      id
      phone
    }
  }`;
};

const query = type => {
  return ` {
    get${type} {
      id
      phone
    }
  }`;
};

export const inputStyle = {
  width: '3em',
  height: '4em',
  margin: '0 10px',
  border: 'none',
  borderBottom: 'solid 2px #c4b6ba',
  color: '#754af6',
  fontSize: '20px',
  fontWeight: '600',
  outline: 'none',
  borderRadius: 5,
  boxShadow: '0 0.5px 0 0 #ffffff inset, 0 1px 3px 0 #B3B3B3',
};

const RadioGroup = Radio.Group;

class SignIn extends AuthPiece {
  constructor() {
    super();

    this.state = {
      authenticated: false,
      mfa: false,
      userId: '',
      visible: false,
      manualConfig: false,
      secret: '',
      setupTOTP: false,
      qrcodeImage: '',
      verifyTOTPError: false,
      confirmationLeft: false,
      forgotPassModal: false,
      openForgotPasswordSubmitModal: false,
      forgotPasswordError: '',
      forgotPasswordSuccess: false,
      rememberMe: false,
      username: '',
      password: '',
      isNewNumber: 1,
      showPreferedMFA: false,
      mfaType: '',
      showRelogin: false,
      mfaSetError: false,
      phoneVerified: false,
      showPhoneVerify: false,
      phoneVerifyError: '',
      showPhoneModal: false,
      phoneModalError: '',
      placeholder: '',
      userType: '',
      providerId: null,
      newPhone: '',
      invalidTOTP: false,
      showNewPasswordModal: false,
      mfaEnabled: false,
    };

    Amplify.configure({
      API: {
        graphql_endpoint: graphql_endpoint.BTPORTAL,
      },
    });
  }

  componentDidMount() {
    const { state } = this.props.location;
    if (state) {
      this.props.history.replace({ ...this.props.location, state: undefined });
    }
  }

  // componentDidMount() {
  //   const username = cookies.get('username');
  //   const password = cookies.get('password');

  //   if(username && password) {
  //     this.setState({ rememberMe: true, username, password })
  //   }
  // }

  // changeRememberMe = ({target: { checked }}) => {
  //   if (!checked) {
  //     cookies.remove('username');
  //     cookies.remove('password');
  //   }

  //   this.setState({ rememberMe: checked })
  // }

  getProviderId = () => {
    API.graphql(graphqlOperation(query(this.state.userType))).then(({ data }) => {
      this.setState({ providerId: data[`get${this.state.userType}`].id });
    });
  };

  showModal = () => {
    store.dispatch({ type: 'IS_FIRST_TIME_LOGIN' });
    this.setState({
      // visible: true,
      isNewNumber: 1,
      newPhone: '',
      showPreferedMFA: true,
    });
    // this.setupTOTP();
  };

  handleOk = e => {
    this.setState({
      visible: false,
    });
  };

  handleCancel = e => {
    this.setState({
      visible: false,
      verifyTOTPError: false,
      showConfirmSignupForm: false,
      confError: false,
      confirmationErrMsg: '',
      forgotPassModal: false,
      openForgotPasswordSubmitModal: false,
      forgotPasswordError: '',
      forgotPasswordSuccess: false,
      username: '',
      password: '',
      showPreferedMFA: false,
      showRelogin: false,
      mfaSetError: false,
      showPhoneVerify: false,
      phoneVerifyError: '',
      showPhoneModal: false,
      invalidTOTP: false,
      showNewPasswordModal: false,
      isLoading: false,
    });

    this.inputs.mfaVerifyToken = '';
  };

  handleCredChange = ({ target: { value, name } }) => this.setState({ [name]: value });

  setNewPassword = async () => {
    try {
      await Auth.completeNewPassword(this.state.userId, this.inputs.setNewPassword);
      await this.setState({ password: this.inputs.setNewPassword, showNewPasswordModal: false });
      notification.success({
        message: 'Password updated successfully. Please set your MFA and continue ahead.',
      });
      this.signIn();
    } catch (err) {
      notification.error({ message: err.message });
    }
  };

  signIn = async () => {
    const { username, password } = this.state;
    await this.setState({
      mfaEnabled: false,
      isLoading: true,
    });
    if (!(username && username.length && password && password.length)) {
      this.setState({
        errMessage: 'Username/Password is required',
      });
      return;
    }

    const emailRegexp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!emailRegexp.test(username)) {
      this.setState({
        errMessage: 'Invalid Email',
      });
      return;
    }

    logger.debug('username : ', username);
    Auth.signIn(new sha.sha256().update(username).digest('hex'), password)
      .then(user => {
        if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
          return this.setState({ showNewPasswordModal: true, userId: user });
        }
        // if (this.state.rememberMe) {
        //   cookies.set('username', username, { path: '/', expires: new Date(new Date().getTime()+(60*24*60*60*1000)) })
        //   cookies.set('password', password, { path: '/', expires: new Date(new Date().getTime()+(60*24*60*60*1000)) })
        // }

        // this.changeState('signedIn', user);
        const userGroup =
          (user.signInUserSession && user.signInUserSession.idToken.payload['cognito:groups']) ||
          [];
        // let userRoles = (user.signInUserSession && user.signInUserSession.idToken.payload['custom:teamRoles']) || [];
        // localStorage.setItem('custom:teamRoles', JSON.parse(userRoles));
        const allowedGroups = [
          'Therapists',
          'Psychiatrists',
          'TreatmentCenters',
          'TeamMembers',
          'SupportGroups',
          'coordinators',
        ];
        let success = true;
        userGroup.forEach(v => {
          if (allowedGroups.includes(v)) {
            if (v === 'Therapists') {
              this.setState({ userType: 'Therapist' });
            } else if (v === 'Psychiatrists') {
              this.setState({ userType: 'Psychiatrist' });
            } else if (v === 'TreatmentCenters') {
              this.setState({ userType: 'TreatmentCenter' });
            } else if (v === 'SupportGroups') {
              this.setState({ userType: 'SupportGroup' });
            } else if (v === 'TeamMembers') {
              this.setState({
                userType: 'TeamMember',
              });
            }
            success = false;
          }
        });

        success = success && user.signInUserSession;

        if (success) {
          Auth.signOut();
          this.setState({
            confirmationLeft: true,
            isLoading: false,
          });
        } else {
          if (!user.challengeName) {
            this.getProviderId();
          }

          this.setState({
            placeholder: user.challengeName
              ? user.challengeName === 'SMS_MFA'
                ? 'Enter your authentication code that you received by text just now'
                : 'Enter your authentication code from your google authenticator app'
              : 'Enter your authentication code that you received by text just now',
            userId: user,
            mfa: true,
            errMessage: '',
            isLoading: false,
            phoneVerified: user.signInUserSession
              ? user.signInUserSession.idToken.payload.phone_number_verified
              : false,
          });
        }

        // this.setState({
        //   authenticated: true,
        // });
      })
      .catch(err => {
        this.setState({
          isLoading: false,
        });
        if (err.message === 'User is not confirmed.') {
          Auth.resendSignUp(new sha.sha256().update(username).digest('hex'))
            .then(() => {
              this.setState({
                showConfirmSignupForm: true,
              });
            })
            .catch(e =>
              this.setState({
                errMessage: e.message,
              }),
            );
        } else {
          this.setState({
            errMessage: err.message,
          });
        }
      });
  };

  setupTOTP = () => {
    // Auth.enableSMS(this.state.userId)
    //   .then(enableMfa => {

    Auth.setupTOTP(this.state.userId)
      .then(secret => {
        this.setState({
          secret,
          setupTOTP: true,
        });

        const qname = process.env.REACT_APP_NODE_ENV === 'dev' ? 'BT-Portal-Dev' : 'BT-Portal';
        const otpauth = keyuri(
          this.state.userId.signInUserSession.idToken.payload.email,
          qname,
          secret,
        );
        QRCode.toDataURL(otpauth, (err, imageUrl) => {
          if (err) {
          } else {
            this.setState({
              qrcodeImage: imageUrl,
            });
          }
        });
      })
      .catch(err => console.log(err));
  };

  verifyTOTP = async () => {
    const { verifyMFA } = this.inputs;
    await this.setState({
      mfaLoader: true,
    });
    Auth.verifyTotpToken(this.state.userId, verifyMFA)
      .then(async success => {
        // Auth.confirmSignIn(this.state.userId, verifyMFA, this.state.mfaType)
        //     .then( async(user) => {
        //       console.log('user', user)
        //       console.log('in catch')

        //       // const { 'custom:isOnTrial': isOnTrial, 'custom:subscriptionDue': subscriptionDue } = user.signInUserSession.idToken.payload;
        //       // store.dispatch({ type: 'SET_PREMIUM_STATUS', subscriptionDue, isOnTrial });
        //       let userRoles = user.signInUserSession.idToken.payload['custom:teamRoles'] || [];
        //       await localStorage.setItem('custom:teamRoles', userRoles);
        //       await localStorage.setItem('cognito:username', user.signInUserSession.idToken.payload['cognito:username'] || [] );
        //       await localStorage.setItem('custom:teamOwnerId', user.signInUserSession.idToken.payload['custom:teamOwnerId'] || []);
        //       await getAppsAPI();
        //       await getProgressNoteName();
        //       await getPayersList();
        //       let userGroup = user.signInUserSession.idToken.payload['cognito:groups'] || [];
        //       const allowedGroups = ["Therapists", "Psychiatrists", "TreatmentCenters","TeamMembers", "SupportGroups", "coordinators"];
        //       let success = false;
        //       userGroup.forEach(v => {
        //         if (allowedGroups.includes(v)) {
        //           success = true;
        //         }
        //       });

        //       if (success) {
        //         this.setState({
        //           authenticated: true
        //         });
        //         await getCurrentPlan();
        //         fetchUrl.BTPORTAL(LogUserAuthEvent,{event:'LOGIN_SUCCESS'}).then(({data})=>console.log('LOGIN_SUCCESS'))
        //         fetchUrl.BTPORTAL(GetTherapistProfile,'').then(({data:{getTherapist}})=>{
        //           localStorage.setItem('hasPartialData', getTherapist ? getTherapist.hasPartialData : null);
        //         });

        //         window.sessionStorage.setItem('isLoggedIn', true);
        //         this.changeState('signedIn', user);
        //       } else {
        //         Auth.signOut();
        //         this.setState({
        //           mfa: false,
        //           userId: '',
        //           confirmationLeft: true
        //         });
        //       }
        //     })
        //     .catch(err => {
        //       console.log('in catch', err)
        //       this.setState({ invalidTOTP: true })
        //       Auth.signOut();
        //     });
        await Auth.setPreferredMFA(this.state.userId, 'TOTP')
          .then(preferedMFA => {
            Auth.signOut();
            this.setState({
              mfa: false,
              userId: '',
              setupTOTP: false,
              visible: false,
              mfaLoader: false,
              mfaEnabled: true,
            });
            // window.sessionStorage.setItem('isLoggedIn', true);
            // this.changeState('signedIn', this.state.userId);
          })
          .catch(err =>
            this.setState({
              mfaLoader: false,
            }),
          );
      })
      .catch(err =>
        this.setState({
          verifyTOTPError: true,
          mfaLoader: false,
        }),
      );
  };

  mfaPass = async () => {
    await this.setState({
      isLoading: true,
    });
    const { mfaVerifyToken } = this.inputs;
    this.setState({ invalidTOTP: false });
    // Need to revisit when MFA Authentication is enabled
    Auth.confirmSignIn(this.state.userId, mfaVerifyToken, this.state.userId.challengeName)
      .then(async user => {
        // const { 'custom:isOnTrial': isOnTrial, 'custom:subscriptionDue': subscriptionDue } = user.signInUserSession.idToken.payload;
        // store.dispatch({ type: 'SET_PREMIUM_STATUS', subscriptionDue, isOnTrial });

        const userRoles = user.signInUserSession.idToken.payload['custom:teamRoles'] || [];
        localStorage.setItem('custom:teamRoles', userRoles);
        localStorage.setItem('isLockHide', 'true');
        localStorage.setItem(
          'custom:premiumOverride',
          user.signInUserSession.idToken.payload['custom:premiumOverride'],
        );
        localStorage.setItem(
          'custom:professionalOverride',
          user.signInUserSession.idToken.payload['custom:professionalOverride'],
        );
        localStorage.setItem(
          'cognito:username',
          user.signInUserSession.idToken.payload['cognito:username'] || [],
        );
        localStorage.setItem(
          'custom:teamOwnerId',
          user.signInUserSession.idToken.payload['custom:teamOwnerId'] || [],
        );
        localStorage.setItem('email', user.signInUserSession.idToken.payload.email || []);

        // await getTherapistInfo();
        // await getProviderPlans();

        // Initial APIS
        await getAppsAPI();
        await getEnterprisePlan();
        await getProgressNoteName();
        await getPracticeTimezone();
        await getPayersList().catch(error => console.log('------------------------', error));

        const userGroup = user.signInUserSession.idToken.payload['cognito:groups'] || [];
        const allowedGroups = [
          'Therapists',
          'Psychiatrists',
          'TreatmentCenters',
          'SupportGroups',
          'coordinators',
          'TeamMembers',
        ];
        let success = false;
        userGroup.forEach(v => {
          if (allowedGroups.includes(v)) {
            success = true;
          }
        });

        if (success) {
          this.setState({
            authenticated: true,
          });
          await getCurrentPlan().catch(console.log);
          fetchUrl
            .BTPORTAL(LogUserAuthEvent, { event: 'LOGIN_SUCCESS' })
            .then(({ data }) => console.log('LOGIN_SUCCESS'));
          // fetchUrl.BTPORTAL(GetTherapistProfile, '').then(({ data: { getTherapist } }) => {
          //   localStorage.setItem('hasPartialData', getTherapist ? getTherapist.hasPartialData : null);
          // });

          window.sessionStorage.setItem('isLoggedIn', true);
          this.props.history.replace('/app/clients');
          this.changeState('signedIn', user);
        } else {
          Auth.signOut();
          this.setState({
            mfa: false,
            userId: '',
            confirmationLeft: true,
          });
        }
      })
      .catch(err => {
        this.setState({ invalidTOTP: false, isLoading: false });
      });
  };

  setSMSMfa = () => {
    const { userId } = this.state;
    Auth.setPreferredMFA(userId, 'SMS')
      .then(async res => {
        await Auth.signOut();
        // this.handleCancel();
        this.setState({
          showPreferedMFA: false,
          showPhoneVerify: false,
          showRelogin: true,
          mfa: false,
          phoneLoading: false,
        });
      })
      .catch(err => this.setState({ mfaSetError: true, phoneLoading: false }));
  };

  setMfaType = () => {
    const { mfaType } = this.state;
    if (mfaType === 'SMS') {
      this.setSMSMfa();
    } else {
      this.setState({ visible: true, showPreferedMFA: false });
      this.setupTOTP();
    }
  };

  openVerifyPhoneModal = () => {
    this.setState({
      showPreferedMFA: false,
      showPhoneModal: true,
    });
  };

  verifyPhone = () => {
    this.setState({ showPhoneModal: false, showPhoneVerify: true, disableBtn: false });
    Auth.verifyCurrentUserAttribute('phone_number').catch(err =>
      this.setState({ phoneVerifyError: 'Error in verification. Try Again!' }),
    );
  };

  updatePhone = async () => {
    this.setState({
      disableBtn: true,
    });
    await Auth.updateUserAttributes(this.state.userId, { phone_number: this.state.newPhone })
      .then(() => {
        if (this.state.userType && this.state.providerId) {
          API.graphql(
            graphqlOperation(mutation(this.state.userType), {
              id: this.state.providerId,
              input: { phone: this.state.newPhone },
            }),
          );
        }
        this.verifyPhone();
      })
      .catch(err => this.setState({ phoneModalError: 'Invalid Phone Number.', disableBtn: false }));
  };

  verifyPhoneSubmit = () => {
    const { phoneVerifyInput } = this.inputs;
    this.setState({
      phoneLoading: true,
    });
    Auth.verifyCurrentUserAttributeSubmit('phone_number', phoneVerifyInput)
      .then(() => {
        this.setState({ showPreferedMFA: false, phoneVerified: true });
        this.setSMSMfa();
      })
      .catch(err => this.setState({ phoneVerifyError: 'Invalid code', phoneLoading: false }));
  };

  handleInputPhoneChange = newPhone => {
    this.setState({ newPhone });
  };

  changePreferedMfa = async e => {
    await this.setState({
      mfaType: e.target.value,
      mfaSetError: false,
    });
  };

  confirmSignup = () => {
    const { signupConfirmationCode } = this.inputs;
    const { username } = this.state;

    Auth.confirmSignUp(new sha.sha256().update(username).digest('hex'), signupConfirmationCode)
      .then(() => {
        this.setState({
          showConfirmSignupForm: false,
        });
      })
      .catch(e => {
        this.setState({
          confError: true,
          confirmationErrMsg: e.message,
        });
      });
  };

  openForgotPassword = () => {
    this.setState({
      forgotPassModal: true,
    });
  };

  handleNumberChange = e => {
    this.setState({
      isNewNumber: e.target.value,
      newPhone: '',
    });
  };

  requestForgotPassword = async () => {
    const { forgotPassUsername } = this.inputs;
    const emailRegexp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!emailRegexp.test(forgotPassUsername)) {
      await this.setState({
        forgotPasswordError: 'Please enter a valid email',
      });
      return false;
    }

    Auth.forgotPassword(new sha.sha256().update(forgotPassUsername).digest('hex'))
      .then(() => this.setState({ openForgotPasswordSubmitModal: true, forgotPasswordError: '' }))
      .catch(e => this.setState({ forgotPasswordError: e.message }));
  };

  forgotPassSubmit = async () => {
    const { forgotPassUsername, newPassword, code } = this.inputs;
    const passwordRegexp = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/;
    if (!passwordRegexp.test(newPassword)) {
      await this.setState({
        forgotPasswordError:
          'Password must contain eight characters, at least one uppercase letter, one lowercase letter and one number',
      });
      return false;
    }
    Auth.forgotPasswordSubmit(
      new sha.sha256().update(forgotPassUsername).digest('hex'),
      code,
      newPassword,
    )
      .then(() => {
        this.handleCancel();
        this.setState({
          forgotPasswordSuccess: true,
        });
      })
      .catch(e => this.setState({ forgotPasswordError: e.message }));
  };

  renderOtpInput = (key, style = {}) => (
    <OtpInput
      isInputNum
      shouldAutoFocus
      numInputs={6}
      value={this.inputs[key]}
      inputStyle={inputStyle}
      hasErrored={false}
      containerStyle={{ justifyContent: 'center', margin: '30px 0', ...style }}
      onChange={e => {
        this.inputs[key] = e;
        this.setState({
          [key]: e,
        });
      }}
      focusStyle={{ background: '#754af622' }}
      errorStyle={{
        borderBottom: 'solid 2px red',
      }}
    />
  );

  render() {
    const mfaDownloadInst =
      'Download Google Authenticator App from <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2" target="_blank">Play Store</a> or <a href="https://itunes.apple.com/in/app/google-authenticator/id388497605" target="_blank">App Store</a>. Then click the + sign and scan the bar code above. It will add a new entry. Going forward you will use the code from this entry every time you signin, when it asks for MFA Code.';
    return (
      <Fragment>
        <div className='split right'>
          <div className='centered' style={{ width: '100%' }}>
            <SignInStyleWrapper
              className='isoSignInPage'
              style={{ minHeight: '100%', background: 'transparent' }}
            >
              {/* <Header {...this.props} /> */}
              <div className='content'>
                <div className='isoLoginContentWrapper'>
                  <div
                    className='auth-box login-box'
                    style={{ width: this.state.mfa ? 'fit-content' : 'auto' }}
                  >
                    <div className='login-text' style={{ color: '#6662ce' }}>
                      {this.state.mfa ? 'Authentication Code' : 'Login'}
                    </div>
                    <div className='isoLoginContent'>
                      {this.state.errMessage ? (
                        <div style={{ color: 'red', padding: '0 0 10px' }}>
                          {this.state.errMessage}
                        </div>
                      ) : (
                        ''
                      )}
                      <div className={this.state.mfa ? 'isoSignInForm hide' : 'isoSignInForm show'}>
                        {/* <Federated federated={federated_data} onStateChange={this.handleAuthStateChange} /> */}
                        {this.state.mfaEnabled ? (
                          <Alert
                            message={
                              <div>
                                Your MFA for this account has been setup successfully. Please click
                                the Next button to continue.
                              </div>
                            }
                            type='success'
                            showIcon
                            style={{ marginBottom: '20px' }}
                          />
                        ) : this.state.confirmationLeft ? (
                          <Alert
                            message='Your account has not been confirmed. We will get back with you soon'
                            type='error'
                            showIcon
                            style={{ marginBottom: '20px' }}
                          />
                        ) : null}
                        {this.state.showRelogin ? (
                          <Alert
                            message='Your MFA setup is successfull. Please login again.'
                            type='success'
                            showIcon
                            style={{ marginBottom: '20px' }}
                          />
                        ) : null}
                        {this.state.forgotPasswordSuccess ? (
                          <Alert
                            message='Your password has been changed successfully.'
                            type='success'
                            showIcon
                            style={{ marginBottom: '20px' }}
                          />
                        ) : null}
                        <div className='isoInputWrapper'>
                          <Input
                            size='large'
                            type='text'
                            placeholder='Username / Email'
                            name='username'
                            value={this.state.username}
                            onChange={this.handleCredChange}
                          />
                        </div>
                        <div className='isoInputWrapper'>
                          <Input
                            onPressEnter={this.signIn}
                            size='large'
                            type='password'
                            placeholder='Password'
                            name='password'
                            value={this.state.password}
                            onChange={this.handleCredChange}
                          />
                        </div>
                        <div
                          className='isoInputWrapper isoLeftRightComponent'
                          style={{ display: 'flex', flexDirection: 'row-reverse' }}
                        >
                          {/* <Checkbox checked={this.state.rememberMe} onChange={this.changeRememberMe}>
                    Remember Me
              </Checkbox> */}
                          <a onClick={this.openForgotPassword} className='med-text'>
                            Forgot Password
                          </a>
                        </div>
                        <Button
                          loading={this.state.isLoading}
                          style={{ width: '100%', color: 'white' }}
                          className='bt_portal-button -primary'
                          onClick={this.signIn}
                        >
                          Next
                        </Button>
                        <div
                          className='isoCenterComponent isoHelperWrapper'
                          style={{ marginTop: '20px' }}
                        >
                          <Link style={{ display: 'block' }} to='/signup'>
                            <a className='disabled-text med-text' style={{ color: '#444' }}>
                              Don't have a account?
                            </a>{' '}
                            <span className='med-text'>Signup</span>{' '}
                          </Link>
                        </div>
                      </div>
                      <div
                        className={this.state.mfa ? 'isoSignInForm show' : 'isoSignInForm hide'}
                        style={{ paddingTop: 0 }}
                      >
                        {this.state.invalidTOTP ? (
                          <Alert
                            message='Invalid OTP entered'
                            type='error'
                            showIcon
                            style={{ marginBottom: '20px' }}
                          />
                        ) : null}
                        <p className='verification-text'>{this.state.placeholder}</p>
                        <div className='isoInputWrapper'>
                          {this.renderOtpInput('mfaVerifyToken')}
                          {/* <Input */}
                          {/*  onPressEnter={this.mfaPass} */}
                          {/*  size='large' */}
                          {/*  type='text' */}
                          {/*  placeholder={this.state.placeholder} */}
                          {/*  name='mfaVerifyToken' */}
                          {/*  onChange={this.handleInputChange} */}
                          {/* /> */}
                        </div>
                        <div
                          className='isoInputWrapper isoLeftRightComponent'
                          style={{ justifyContent: 'flex-end' }}
                        >
                          {this.state.userId.challengeName === 'SOFTWARE_TOKEN_MFA' ||
                          this.state.userId.challengeName === 'SMS_MFA' ? (
                            <a
                              style={{ width: '100%' }}
                              href='mailto:help@resiliens.com?subject=Resync MFA&body=I have a lost my MFA Device and thus cannot login to Better Therapist Portal website. I need someone to assist me quickly.'
                            >
                              Lost your MFA Device?
                            </a>
                          ) : (
                            <a onClick={this.showModal} className='setup-two-factor'>
                              Set up Two-Factor Authentication
                            </a>
                          )}

                          {/* <Link style={{ display: 'block'}} to="/" onClick={this.showModal}>Setup MFA </Link> */}

                          <Modal
                            centered
                            className='account-exists-modal'
                            style={{ top: 20 }}
                            width={700}
                            title='Set-up MFA'
                            visible={this.state.visible}
                            onOk={this.verifyTOTP}
                            okText='Enable MFA'
                            cancelButtonProps={{
                              className: 'bt_portal-bt_portal-button -disabled -outlined',
                            }}
                            okButtonProps={{
                              type: 'primary',
                              className: 'modal-btn',
                              loading: this.state.mfaLoader,
                            }}
                            onCancel={this.handleCancel}
                          >
                            <div className='isoSignInForm show'>
                              <img
                                style={{ display: 'block', margin: '0 auto 20px' }}
                                src={this.state.qrcodeImage}
                                width='220'
                                height='220'
                                alt='qr code'
                              />
                              <Alert message={renderHTML(mfaDownloadInst)} type='info' showIcon />
                              <a
                                onClick={() => this.setState({ manualConfig: true })}
                                style={{ display: 'block', margin: '20px 0' }}
                                className='manual-config-link'
                                href='javascript:void(0);'
                              >
                                Show secret key for manual configuration
                              </a>

                              {this.state.manualConfig ? (
                                <div className='isoInputWrapper' style={{ marginBottom: '20px' }}>
                                  <Input
                                    size='large'
                                    type='text'
                                    value={this.state.secret}
                                    name='secKey'
                                    readOnly
                                    disabled
                                    style={{
                                      background: '#f8f8f8',
                                      border: 0,
                                    }}
                                  />
                                </div>
                              ) : null}
                              {this.state.verifyTOTPError ? (
                                <Alert
                                  message='Token Entered is Invalid.'
                                  type='error'
                                  showIcon
                                  style={{ marginBottom: '10px' }}
                                />
                              ) : null}
                              <h4 className='verify-mfa-code-title'>Verify MFA Code</h4>

                              <div className='isoInputWrapper'>
                                {this.renderOtpInput('verifyMFA', { marginTop: 15 })}
                              </div>
                            </div>
                          </Modal>

                          <Modal
                            centered
                            style={{ top: 20 }}
                            title='Confirm Email'
                            visible={this.state.showConfirmSignupForm}
                            onOk={this.confirmSignup}
                            okText='Confirm'
                            className='account-exists-modal'
                            cancelButtonProps={{
                              className: 'bt_portal-bt_portal-button -disabled -outlined',
                            }}
                            okButtonProps={{ type: 'primary', className: 'modal-btn' }}
                            onCancel={this.handleCancel}
                          >
                            <div className='isoSignInForm show'>
                              {this.state.confError ? (
                                <Alert
                                  message={this.state.confirmationErrMsg}
                                  type='error'
                                  showIcon
                                  style={{ marginBottom: '20px' }}
                                />
                              ) : null}
                              <p className='verification-text'>
                                We have emailed a verification code to the email you entered. Please
                                enter it in the box below and click the Verify button.
                              </p>
                              <div className='isoInputWrapper'>
                                <Input
                                  size='large'
                                  type='text'
                                  placeholder='Enter Confirmation Code'
                                  name='signupConfirmationCode'
                                  onChange={this.handleInputChange}
                                />
                              </div>
                            </div>
                          </Modal>

                          <Modal
                            centered
                            width={700}
                            className='account-exists-modal'
                            title='Select Two-Factor authentication mode'
                            visible={this.state.showPreferedMFA}
                            onOk={this.setMfaType}
                            okText='Set'
                            cancelButtonProps={{
                              className: 'bt_portal-bt_portal-button -disabled -outlined',
                            }}
                            okButtonProps={{ type: 'primary', className: 'modal-btn' }}
                            onCancel={this.handleCancel}
                          >
                            <div className='isoSignInForm show'>
                              {this.state.mfaSetError ? (
                                <Alert
                                  message='Error in setting MFA. Try Again!'
                                  type='error'
                                  showIcon
                                  style={{ marginBottom: '20px' }}
                                />
                              ) : null}
                              <p className='verification-text'>
                                Two factor authentication improves the security of your account. In
                                addition to your normal credentials, you'll also need to provide an
                                authentication code when logging in.
                              </p>
                              <RadioGroup
                                onChange={this.changePreferedMfa}
                                value={this.state.mfaType}
                                className='mfa-type-radios'
                              >
                                <Row>
                                  <Radio value='SOFTWARE_TOKEN_MFA' className='mfa-type-card'>
                                    <div>
                                      <p className='title medium-text'>Google Authenticator App</p>
                                      <p className='desc'>
                                        In order to use Google MFA, you will need to download and
                                        install the Google Authenticator to your mobile device.
                                        Please do this before continuing.
                                      </p>
                                    </div>
                                  </Radio>
                                </Row>
                                <Row>
                                  <div onClick={this.openVerifyPhoneModal}>
                                    <Radio
                                      value='SMS_MFA'
                                      className='mfa-type-card'
                                      disabled={!this.state.phoneVerified}
                                    >
                                      <p className='title medium-text'>Text Messages (SMS)</p>
                                      <p className='desc light-text' style={{ marginBottom: 10 }}>
                                        You will receive a code via text message (SMS) on your
                                        phone.
                                      </p>
                                      {this.state.phoneVerified ? null : (
                                        <h5
                                          style={{
                                            cursor: 'pointer',
                                            color: '#414141',
                                          }}
                                          className='phone-authenticator'
                                        >
                                          <a>Verify Phone </a>
                                          (You need to verify your phone number to receive code via
                                          text).
                                        </h5>
                                      )}
                                    </Radio>
                                  </div>
                                </Row>
                              </RadioGroup>
                            </div>
                          </Modal>

                          <Modal
                            centered
                            className='account-exists-modal'
                            title='Verify Phone Number'
                            visible={this.state.showPhoneModal}
                            // okButtonProps={{ className: 'hidden' }}
                            onCancel={this.handleCancel}
                            // okButtonDisabled={true}
                            footer={null}
                          >
                            <div className='isoSignInForm show' style={{ textAlign: 'center' }}>
                              {this.state.phoneModalError ? (
                                <Alert
                                  message={this.state.phoneModalError}
                                  type='error'
                                  showIcon
                                  style={{ marginBottom: '20px' }}
                                />
                              ) : null}
                              <Row />

                              <p className='verification-text'>
                                {parseInt(this.state.isNewNumber, 10) === 1
                                  ? 'We will send a verification code to your phone number you provided during registration'
                                  : 'We will send a verification code to your phone number you will provide'}
                              </p>
                              <Row style={{ marginTop: '10px' }}>
                                <Radio.Group
                                  value={parseInt(this.state.isNewNumber, 10)}
                                  onChange={this.handleNumberChange}
                                  style={{ marginBottom: 15 }}
                                >
                                  <Radio value={1}>
                                    Use Phone Number provided during registration
                                  </Radio>
                                  <Radio value={2}>Enter new Phone Number</Radio>
                                </Radio.Group>
                                {parseInt(this.state.isNewNumber, 10) !== 1 ? (
                                  <div className='isoInputWrapper'>
                                    {/* <Input size="large" type="text" placeholder="Enter new phone number" name="newPhone" onChange={this.handleInputChange} /> */}
                                    <PhoneInput
                                      country='US'
                                      className='bt_portal-input ant-input'
                                      placeholder='Enter Phone Number'
                                      value={this.state.newPhone}
                                      displayInitialValueAsLocalNumber
                                      onChange={this.handleInputPhoneChange}
                                    />
                                  </div>
                                ) : (
                                  ''
                                )}
                                <div style={{ marginTop: '40px' }}>
                                  {parseInt(this.state.isNewNumber, 10) === 1 ? (
                                    <Button
                                      type='primary'
                                      className='bt_portal-button -primary -outline'
                                      onClick={this.verifyPhone}
                                      style={{ height: 40 }}
                                    >
                                      Verify Phone Number
                                    </Button>
                                  ) : (
                                    <Button
                                      loading={this.state.disableBtn}
                                      type='primary'
                                      disabled={!this.state.newPhone}
                                      className='bt_portal-button -primary -outline'
                                      onClick={this.updatePhone}
                                      style={{ height: 40 }}
                                    >
                                      Update & Verify Phone Number
                                    </Button>
                                  )}
                                </div>
                              </Row>
                            </div>
                          </Modal>

                          <Modal
                            centered
                            title='Forgot Password'
                            className='account-exists-modal'
                            visible={this.state.forgotPassModal}
                            onOk={this.requestForgotPassword}
                            okText='Next'
                            cancelButtonProps={{
                              className: 'bt_portal-bt_portal-button -disabled -outlined',
                            }}
                            okButtonProps={{ type: 'primary', className: 'modal-btn' }}
                            onCancel={this.handleCancel}
                          >
                            <div className='isoSignInForm show'>
                              {this.state.forgotPasswordError ? (
                                <Alert
                                  message={this.state.forgotPasswordError}
                                  type='error'
                                  showIcon
                                  style={{ marginBottom: '20px' }}
                                />
                              ) : null}

                              <p className='verification-text'>
                                Please enter your email address. We will send you an email to reset
                                your password.
                              </p>

                              <div className='isoInputWrapper'>
                                <Input
                                  size='large'
                                  type='text'
                                  placeholder='Enter Username/Email'
                                  name='forgotPassUsername'
                                  onChange={this.handleInputChange}
                                />
                              </div>
                            </div>
                          </Modal>

                          <Modal
                            centered
                            title='Verify Phone'
                            className='account-exists-modal'
                            visible={this.state.showPhoneVerify}
                            onOk={this.verifyPhoneSubmit}
                            okText={
                              <span>
                                <Icon hidden={!this.state.phoneLoading} type='loading' /> Verify
                              </span>
                            }
                            cancelButtonProps={{
                              className: 'bt_portal-bt_portal-button -disabled -outlined',
                            }}
                            okButtonProps={{ type: 'primary', className: 'modal-btn' }}
                            onCancel={this.handleCancel}
                          >
                            <div className='isoSignInForm show'>
                              {this.state.phoneVerifyError ? (
                                <Alert
                                  message={this.state.phoneVerifyError}
                                  type='error'
                                  showIcon
                                  style={{ marginBottom: '20px' }}
                                />
                              ) : null}

                              <p className='verification-text'>
                                Enter code you just received via text message
                              </p>
                              <div className='isoInputWrapper'>
                                {this.renderOtpInput('phoneVerifyInput')}
                              </div>
                            </div>
                          </Modal>

                          <Modal
                            centered
                            title='Reset Password'
                            className='account-exists-modal'
                            visible={this.state.openForgotPasswordSubmitModal}
                            onOk={this.forgotPassSubmit}
                            okText='Submit'
                            cancelButtonProps={{
                              className: 'bt_portal-bt_portal-button -disabled -outlined',
                            }}
                            okButtonProps={{ type: 'primary', className: 'modal-btn' }}
                            onCancel={this.handleCancel}
                          >
                            <div className='isoSignInForm show'>
                              {this.state.forgotPasswordError ? (
                                <Alert
                                  message={this.state.forgotPasswordError}
                                  type='error'
                                  showIcon
                                  style={{ marginBottom: '20px' }}
                                />
                              ) : null}

                              <p className='verification-text'>
                                We have emailed a verification code to the email you entered. Please
                                enter your New Password and Verification Code in the below boxes.
                              </p>

                              <div className='isoInputWrapper'>
                                <Input
                                  size='large'
                                  type='password'
                                  placeholder='Enter New Password'
                                  name='newPassword'
                                  onChange={this.handleInputChange}
                                />
                              </div>

                              <div className='isoInputWrapper' style={{ marginTop: '20px' }}>
                                <Input
                                  size='large'
                                  type='text'
                                  placeholder='Enter Confirmation code'
                                  name='code'
                                  onChange={this.handleInputChange}
                                />
                              </div>
                            </div>
                          </Modal>

                          <Modal
                            centered
                            title='Set New Password'
                            className='account-exists-modal'
                            visible={this.state.showNewPasswordModal}
                            onOk={this.setNewPassword}
                            okText='Submit'
                            cancelButtonProps={{
                              className: 'bt_portal-bt_portal-button -disabled -outlined',
                            }}
                            okButtonProps={{ type: 'primary', className: 'modal-btn' }}
                            onCancel={this.handleCancel}
                            maskClosable={false}
                          >
                            <div className='isoSignInForm show'>
                              <div className='isoInputWrapper'>
                                <Input
                                  size='large'
                                  type='password'
                                  placeholder='Enter New Password'
                                  name='setNewPassword'
                                  onChange={this.handleInputChange}
                                />
                              </div>
                            </div>
                          </Modal>
                        </div>
                        <Button
                          style={{ width: '100%', color: 'white', marginTop: '10px' }}
                          className='bt_portal-button'
                          onClick={this.mfaPass}
                          loading={this.state.isLoading}
                        >
                          Sign In
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SignInStyleWrapper>
          </div>
        </div>
        <div className='split left'>
          <div className='standard-logo' style={{ marginLeft: '30px' }}>
            <a
              className='logo-with-text'
              href='/'
              style={{ position: 'absolute', zIndex: 111111, top: 20 }}
            >
              <img src={portal_logo} alt='Resiliens Clinician' width={50} height={50} />
              <div>
                <h3 className='bold-text'>Resiliens</h3>
                <h5 className='para-text'>For Clinicians</h5>
              </div>
            </a>
          </div>
          <div className='right-vertical-centered'>
            <img src={logo} alt='Canvas Logo' />
          </div>
        </div>
      </Fragment>
    );
  }
}

const logger = new Logger(SignIn);

export default SignIn;
